"use client";

import { c as _c } from "react/compiler-runtime";
import { Typography } from "@grupa-pracuj/ui-system";
import { useSearchParams } from "next/navigation";
import { useEffect, useRef } from "react";
import messages from "@/messages/pl.json";
import { getMonthName, getResolvedArchiveSearchParams } from "@/utils";
import styles from "./DynamicHeader.module.css";
const DynamicHeader = () => {
  const $ = _c(13);
  const headingRef = useRef(null);
  const isFirstRender = useRef(true);
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = getResolvedArchiveSearchParams({
      year: searchParams.get("year"),
      month: searchParams.get("month"),
      pageNumber: searchParams.get("pageNumber")
    });
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    year,
    month,
    pageNumber
  } = t0;
  const focusTrigger = `${year}-${month}-${pageNumber}`;
  const monthName = getMonthName(Number(year), Number(month) - 1);
  let t1;
  let t2;
  if ($[2] !== focusTrigger) {
    t1 = () => {
      if (!focusTrigger) {
        return;
      }
      if (isFirstRender.current) {
        isFirstRender.current = false;
        return;
      }
      headingRef.current?.focus({
        preventScroll: true
      });
    };
    t2 = [focusTrigger];
    $[2] = focusTrigger;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  const t3 = styles;
  const t4 = -1;
  const T0 = Typography;
  const t5 = "medium";
  const t6 = "span";
  const t7 = messages;
  const t8 = " ";
  const t9 = `${monthName.at(0)?.toLowerCase()}${monthName.slice(1)}`;
  let t10;
  if ($[5] !== T0 || $[6] !== t7.archiveOffers.title || $[7] !== t9 || $[8] !== year) {
    t10 = <T0 size={t5} component={t6}>{t7.archiveOffers.title}{t8}{t9} {year}</T0>;
    $[5] = T0;
    $[6] = t7.archiveOffers.title;
    $[7] = t9;
    $[8] = year;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== t10 || $[11] !== t3.header) {
    t11 = <h2 ref={headingRef} className={t3.header} tabIndex={t4}>{t10}</h2>;
    $[10] = t10;
    $[11] = t3.header;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  return t11;
};
export default DynamicHeader;